import { render, staticRenderFns } from "./AddEquipos.vue?vue&type=template&id=36265d41&scoped=true&"
import script from "./AddEquipos.vue?vue&type=script&lang=ts&"
export * from "./AddEquipos.vue?vue&type=script&lang=ts&"
import style0 from "./AddEquipos.vue?vue&type=style&index=0&id=36265d41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36265d41",
  null
  
)

export default component.exports